export const termsData = [
  {
    id: "section-1",
    heading: "1. Introduction",
    content: [
      "These Terms and Conditions govern the use of the website www.mooshir.com (the 'Website') and the mobile application MOOSHIR (the 'Application'), both operated by FENOVATION SPAS (the 'Company').",
      "The Website and Application are online real estate portals in Algeria designed to facilitate property sales, rentals, and related services.",
    ],
  },
  {
    id: "section-2",
    heading: "2. Definitions",
    content: [
      "**Application**: An interactive electronic service provided by the Company, accessible on internet-connected devices via free download from AppStore, Google Play, or Huawei AppGallery.",
      "**Website**: The online service operated by the Company, accessible at www.mooshir.com.",
      "**Advertisers**: Individuals or entities posting property, service, boost, or advertising listings via online forms.",
      "**Services**: Features such as posting ads, boosting ads, and sending notifications or newsletters.",
      "**Features**: Tools like search, map/list views, chat, saving favorites, and posting ads.",
      "**User**: Any individual using the Website or Application for personal purposes.",
    ],
  },
  {
    id: "section-3",
    heading: "3. General Terms",
    content: [
      "By using the Website or Application, you accept these Terms without restriction. If you disagree, do not use the services.",
      "If the Application is downloaded from an app store, you must comply with that store’s terms.",
      "The Company only facilitates contact between Users and Advertisers and is not responsible for the reliability of advertiser information.",
    ],
  },
  {
    id: "section-4",
    heading: "4. Description of Features and Services",
    content: [
      {
        type: "list",
        items: [
          "Create a personal account to access the Website and/or Application.",
          "Search and view property, service, and ad listings.",
          "Access advertiser contact details.",
          "View ads on interactive 2D maps.",
          "Post property, service, or advertising listings.",
          "Post banner or video advertisements.",
          "Boost ads for greater visibility.",
          "Access a profile area to manage activities.",
          "Use chat for communication between advertisers and users.",
          "Save favorite ads and searches.",
          "Receive notifications for favorites, chat, and alerts.",
        ],
      },
    ],
  },
  {
    id: "section-5",
    heading: "5. Availability",
    content: [
      "The Company aims to provide features and services 24/7 but may modify or interrupt them at any time without notice or compensation.",
      "Availability may be limited by storage capacity or technical issues beyond the Company's control.",
    ],
  },
  {
    id: "section-6",
    heading: "6. Advertiser Identification",
    content: [
      "Advertisers must verify their identity via an Algerian mobile phone number. A verification SMS costing 10–15 DZD (depending on operator) is required before posting the first ad.",
    ],
  },
  {
    id: "section-7",
    heading: "7. User Content Rules",
    content: [
      {
        type: "list",
        items: [
          "Do not interfere with the Website or Application’s operation.",
          "Do not use the services for unlawful purposes or to harm the Company’s reputation.",
          "Do not reuse or exploit content without permission.",
          "Do not use data obtained for unauthorized commercial purposes.",
          "Do not spam other users.",
        ],
      },
    ],
  },
  {
    id: "section-8",
    heading: "8. Data Collection",
    content: [
      "Personal data is stored until account deletion and is used to create accounts, adapt display preferences, remember form inputs, and send recommendations based on favorites and browsing.",
    ],
  },
  {
    id: "section-9",
    heading: "9. Hyperlinks",
    content: [
      "External links do not imply Company responsibility.",
      "Users may not create deep links, bypass authentication, scrape content, or frame the site without permission.",
    ],
  },
  {
    id: "section-10",
    heading: "10. Modifications",
    content: [
      "The Company may update these Terms at any time without prior notice.",
    ],
  },
  {
    id: "section-11",
    heading: "11. Newsletters and Notifications",
    content: [
      "Users may receive Company news and offers via email or notifications.",
      "You can manage or opt out of communications in your account settings or via unsubscribe links.",
    ],
  },
  {
    id: "section-12",
    heading: "12. Report Abuse",
    content: [
      "The Company does not monitor all listings. Users who find illegal or inappropriate content should report it.",
    ],
  },
  {
    id: "section-13",
    heading: "13. Disputes",
    content: [
      "These Terms are governed by Algerian law. Disputes will be handled by Algerian courts.",
    ],
  },
  {
    id: "section-14",
    heading: "14. Contact",
    content: [
      "FENOVATION SPAS, Algeria Venture, Dounia Parc – Dely Ibrahim.",
      "**Email:** contact@mooshir.com",
      "**Phone:** +213 553 430 012",
      "**Website:** www.mooshir.com",
    ],
  },
];
